module.exports = __webpack_public_path__ + "img/cg-logo-small.50d3f70f.png";